import { atom } from "recoil"

export const stopClientExpandingAtom = atom<boolean>({
  key: "stopClientExpandingAtom",
  default: true
})
